import {
  AGE,
  DECUMULATION_DISTRIBUTION_YEARS,
  DECUMULATION_YEARLY_DISTRIBUTION,
  EARMARKED_ACCOUNTS,
  TAX_FILING_STATE,
} from '../SummaryConstants';

const DICTIONARY = {
  [AGE]: {
    iterator: [0, 0],
    title: 'Age',
  },
  [TAX_FILING_STATE]: {
    iterator: [1, 0],
    title: 'Tax Filing State',
  },
  [EARMARKED_ACCOUNTS]: {
    iterator: [2, 0],
    title: 'Earmarked Accounts',
  },
  [DECUMULATION_YEARLY_DISTRIBUTION]: {
    iterator: [3],
    title: 'Distributions',
  },
  [DECUMULATION_DISTRIBUTION_YEARS]: {
    iterator: [4],
    title: 'Distribute over',
  },
};

export const brinkerDictionary = earmarkedAccountsTitle => ({
  [AGE]: {
    iterator: [0, 0],
    title: 'Age',
  },
  [TAX_FILING_STATE]: {
    iterator: [1, 0],
    title: 'Tax Filing State',
  },
  [EARMARKED_ACCOUNTS]: {
    iterator: [2, 0],
    title: earmarkedAccountsTitle,
    readOnly: true,
  },
  [DECUMULATION_YEARLY_DISTRIBUTION]: {
    iterator: [3],
    title: 'Distributions',
  },
  [DECUMULATION_DISTRIBUTION_YEARS]: {
    iterator: [4],
    title: 'Distribute over',
  },
});

export default DICTIONARY;
